import React, { useState, useEffect, useRef } from "react";
import {
  ArrowLeft,
  Edit2,
  User,
  Calendar as CalendarIcon,
  DollarSign,
  TrendingUp,
  MapPin,
  CheckCircle,
  PlusCircle,
  Layers,
  Shield,
  Download,
  FileText,
  ChevronLeft,
  ChevronRight,
  Trash2,
  AlertTriangle,
} from "lucide-react";
import { useHistory, useParams } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import { MyDomain } from "../../../App";
import BossUpdateEmployeeModal from "../BossEmployeeComps/BossUpdateEmployeeModal";
import BossCreateDayWork from "../BossDailyWorkComps/BossCreateDailyWork";
import { useTranslation } from "react-i18next";

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@500&display=swap');

  .bse2 * { box-sizing: border-box; }
  .bse2 { font-family: 'Plus Jakarta Sans', sans-serif; background: #F0F2F7; color: #111827; }

  .bse2-header {
    background: #fff;
    border-bottom: 1px solid #E5E7EB;
    padding: 18px 18px 16px;
    position: sticky; top: 0; z-index: 20;
  }
  .bse2-topbar {
    display: flex; align-items: center; justify-content: space-between;
    margin-bottom: 16px;
  }
  .bse2-back {
    width: 36px; height: 36px; border-radius: 10px;
    border: 1px solid #E5E7EB; background: #F9FAFB;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; color: #374151; transition: all 0.15s;
  }
  .bse2-back:hover { border-color: #3B82F6; color: #3B82F6; background: #EFF6FF; }

  .bse2-actions { display: flex; align-items: center; gap: 8px; }
  .bse2-action-btn {
    width: 36px; height: 36px; border-radius: 10px;
    border: 1px solid #E5E7EB; background: #F9FAFB;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; transition: all 0.15s;
  }
  .bse2-action-btn.export { border-color: #D1FAE5; background: #F0FDF4; color: #059669; }
  .bse2-action-btn.export:hover { background: #DCFCE7; border-color: #059669; }
  .bse2-action-btn.edit { border-color: #EDE9FE; background: #F5F3FF; color: #7C3AED; }
  .bse2-action-btn.edit:hover { background: #EDE9FE; border-color: #7C3AED; }
  .bse2-action-btn.delete { border-color: #FEE2E2; background: #FFF5F5; color: #DC2626; }
  .bse2-action-btn.delete:hover { background: #FEE2E2; border-color: #DC2626; }

  .bse2-delete-overlay {
    position: fixed; inset: 0; background: rgba(0,0,0,0.5);
    display: flex; align-items: flex-end; justify-content: center;
    z-index: 100; padding: 0 0 20px;
  }
  @media (min-width: 640px) {
    .bse2-delete-overlay { align-items: center; padding: 16px; }
  }
  .bse2-delete-sheet {
    background: #fff; border-radius: 24px 24px 0 0; width: 100%; max-width: 480px;
    padding: 24px; box-shadow: 0 -8px 40px rgba(0,0,0,0.15);
    animation: bse2-slide-up 0.25s ease-out;
  }
  @media (min-width: 640px) {
    .bse2-delete-sheet { border-radius: 20px; }
  }
  @keyframes bse2-slide-up {
    from { transform: translateY(60px); opacity: 0; }
    to   { transform: translateY(0);    opacity: 1; }
  }
  .bse2-delete-icon-wrap {
    width: 52px; height: 52px; border-radius: 16px;
    background: #FEF2F2; display: flex; align-items: center; justify-content: center;
    margin: 0 auto 14px;
  }
  .bse2-delete-title { font-size: 17px; font-weight: 700; color: #111827; text-align: center; margin-bottom: 6px; }
  .bse2-delete-desc { font-size: 13px; color: #6B7280; text-align: center; line-height: 1.6; margin-bottom: 20px; }
  .bse2-delete-btns { display: flex; gap: 10px; }
  .bse2-delete-cancel {
    flex: 1; padding: 12px; border-radius: 12px;
    border: 1.5px solid #E5E7EB; background: #F9FAFB;
    font-size: 14px; font-weight: 600; color: #374151;
    cursor: pointer; transition: background 0.15s;
  }
  .bse2-delete-cancel:hover { background: #F3F4F6; }
  .bse2-delete-confirm {
    flex: 1; padding: 12px; border-radius: 12px;
    border: none; background: #DC2626;
    font-size: 14px; font-weight: 700; color: #fff;
    cursor: pointer; transition: background 0.15s;
    display: flex; align-items: center; justify-content: center; gap: 6px;
  }
  .bse2-delete-confirm:hover:not(:disabled) { background: #B91C1C; }
  .bse2-delete-confirm:disabled { opacity: 0.6; cursor: not-allowed; }

  .bse2-export-wrap { position: relative; }
  .bse2-export-menu {
    position: absolute; right: 0; top: 42px;
    background: #fff; border: 1px solid #E5E7EB;
    border-radius: 12px; box-shadow: 0 8px 24px rgba(0,0,0,0.12);
    z-index: 50; min-width: 170px; overflow: hidden;
  }
  .bse2-export-item {
    display: flex; align-items: center; gap: 10px;
    padding: 11px 14px; font-size: 13px; font-weight: 500;
    color: #374151; cursor: pointer; transition: background 0.12s;
    border: none; background: none; width: 100%; text-align: left;
  }
  .bse2-export-item:hover { background: #F9FAFB; }
  .bse2-export-sep { height: 1px; background: #F3F4F6; }

  .bse2-emp-row { display: flex; align-items: center; gap: 12px; margin-bottom: 14px; }
  .bse2-avatar {
    width: 50px; height: 50px; border-radius: 14px;
    background: linear-gradient(135deg, #DBEAFE, #3B82F6);
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0;
  }
  .bse2-emp-name { font-size: 18px; font-weight: 700; color: #111827; letter-spacing: -0.02em; line-height: 1.2; }
  .bse2-emp-sub { display: flex; align-items: center; gap: 6px; margin-top: 4px; }
  .bse2-emp-label { font-size: 11px; color: #6B7280; }
  .bse2-salary-badge {
    display: inline-flex; align-items: center; gap: 4px;
    padding: 3px 8px; border-radius: 6px;
    font-size: 10px; font-weight: 700; letter-spacing: 0.04em;
  }
  .bse2-salary-badge.monthly { background: #EDE9FE; color: #7C3AED; }
  .bse2-salary-badge.daily { background: #D1FAE5; color: #059669; }

  .bse2-salary-strip {
    display: flex; align-items: center; justify-content: space-between;
    background: #F9FAFB; border: 1px solid #E5E7EB;
    border-radius: 10px; padding: 10px 14px;
  }
  .bse2-salary-strip-lbl { font-size: 11px; color: #6B7280; font-weight: 500; }
  .bse2-salary-strip-val {
    font-family: 'JetBrains Mono', monospace;
    font-size: 15px; font-weight: 700; color: #111827;
  }

  .bse2-body { padding: 14px 16px 80px; }

  .bse2-month-section { margin-bottom: 16px; }
  .bse2-section-title {
    font-size: 12px; font-weight: 700; color: #6B7280;
    letter-spacing: 0.1em; text-transform: uppercase;
    margin-bottom: 10px;
  }
  .bse2-month-row { display: flex; align-items: center; gap: 6px; }
  .bse2-month-arrow {
    width: 30px; height: 30px; border-radius: 8px;
    border: 1px solid #E5E7EB; background: #fff;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; color: #6B7280; transition: all 0.15s;
    flex-shrink: 0;
  }
  .bse2-month-arrow:hover { border-color: #3B82F6; color: #3B82F6; background: #EFF6FF; }

  .bse2-month-scroll-wrap { flex: 1; overflow: hidden; position: relative; }
  .bse2-month-scroll-wrap::before,
  .bse2-month-scroll-wrap::after {
    content: ''; position: absolute; top: 0; bottom: 0; width: 20px; z-index: 2; pointer-events: none;
  }
  .bse2-month-scroll-wrap::before { left: 0; background: linear-gradient(to right, #F0F2F7, transparent); }
  .bse2-month-scroll-wrap::after  { right: 0; background: linear-gradient(to left, #F0F2F7, transparent); }

  .bse2-month-track {
    display: flex; gap: 6px;
    overflow-x: auto; scroll-behavior: smooth;
    padding: 2px 4px; scrollbar-width: none;
  }
  .bse2-month-track::-webkit-scrollbar { display: none; }

  .bse2-month-btn {
    flex-shrink: 0; width: 64px; padding: 8px 6px;
    border-radius: 10px; border: 1.5px solid #E5E7EB;
    background: #fff; cursor: pointer; text-align: center;
    transition: all 0.18s ease;
  }
  .bse2-month-btn:hover { border-color: #93C5FD; background: #EFF6FF; }
  .bse2-month-btn.active {
    background: #3B82F6; border-color: #3B82F6;
    box-shadow: 0 3px 10px rgba(59,130,246,0.35);
    transform: scale(1.06);
  }
  .bse2-month-name { font-size: 13px; font-weight: 700; display: block; color: #374151; line-height: 1.2; }
  .bse2-month-btn.active .bse2-month-name { color: #fff; }
  .bse2-month-year {
    font-size: 9px; font-weight: 500; color: #9CA3AF;
    font-family: 'JetBrains Mono', monospace;
    display: block; margin-top: 2px;
  }
  .bse2-month-btn.active .bse2-month-year { color: rgba(255,255,255,0.75); }

  .bse2-summary { display: flex; gap: 8px; margin-bottom: 14px; }
  .bse2-sum-card {
    flex: 1; background: #fff; border-radius: 12px;
    border: 1px solid #E5E7EB; border-bottom: 3px solid transparent;
    padding: 10px 8px; text-align: center; transition: box-shadow 0.15s;
  }
  .bse2-sum-card:hover { box-shadow: 0 2px 8px rgba(0,0,0,0.07); }
  .bse2-sum-card.blue { border-bottom-color: #3B82F6; }
  .bse2-sum-card.green { border-bottom-color: #059669; }
  .bse2-sum-card.purple { border-bottom-color: #7C3AED; }
  .bse2-sum-ico {
    width: 30px; height: 30px; border-radius: 8px;
    display: flex; align-items: center; justify-content: center;
    margin: 0 auto 6px;
  }
  .bse2-sum-ico.blue { background: #EFF6FF; }
  .bse2-sum-ico.green { background: #D1FAE5; }
  .bse2-sum-ico.purple { background: #EDE9FE; }
  .bse2-sum-val { font-size: 15px; font-weight: 800; color: #111827; letter-spacing: -0.02em; }
  .bse2-sum-lbl { font-size: 9px; font-weight: 600; color: #9CA3AF; text-transform: uppercase; letter-spacing: 0.06em; margin-top: 2px; }

  .bse2-monthly-note {
    display: flex; align-items: center; gap: 8px;
    background: #F5F3FF; border: 1px solid #DDD6FE;
    border-radius: 10px; padding: 9px 12px;
    margin-bottom: 14px;
    font-size: 12px; font-weight: 600; color: #7C3AED;
  }

  .bse2-wh-header {
    display: flex; align-items: center; justify-content: space-between;
    margin-bottom: 10px;
  }
  .bse2-wh-title { font-size: 13px; font-weight: 700; color: #111827; text-transform: uppercase; letter-spacing: 0.08em; }
  .bse2-wh-month-badge {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px; font-weight: 600; color: #3B82F6;
    background: #EFF6FF; border: 1px solid #BFDBFE;
    border-radius: 6px; padding: 3px 8px;
  }

  /* ── Day grid — bigger cards ── */
  .bse2-day-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(115px, 1fr));
    gap: 10px;
  }

  .bse2-day {
    background: #fff;
    border: 1.5px solid #E5E7EB;
    border-radius: 12px;
    padding: 11px 10px;
    min-height: 118px;
    cursor: pointer;
    position: relative;
    transition: all 0.18s ease;
    display: flex; flex-direction: column;
  }
  .bse2-day:hover { box-shadow: 0 4px 14px rgba(0,0,0,0.1); transform: translateY(-2px); }
  .bse2-day.worked { border-color: #6EE7B7; background: #F0FDF4; }
  .bse2-day.today { border-color: #3B82F6; box-shadow: 0 0 0 2px rgba(59,130,246,0.2); }
  .bse2-day.today.worked { border-color: #3B82F6; }

  .bse2-day-top {
    display: flex; justify-content: space-between; align-items: flex-start;
    margin-bottom: 8px; padding-bottom: 7px; border-bottom: 1px solid #F3F4F6;
  }
  .bse2-day.worked .bse2-day-top { border-bottom-color: #D1FAE5; }
  .bse2-day-num { font-size: 18px; font-weight: 800; color: #D1D5DB; line-height: 1; }
  .bse2-day.worked .bse2-day-num { color: #059669; }
  .bse2-day.today .bse2-day-num { color: #3B82F6; }
  .bse2-day-name { font-size: 9px; font-weight: 700; color: #9CA3AF; text-transform: uppercase; letter-spacing: 0.06em; }
  .bse2-day.worked .bse2-day-name { color: #6B7280; }

  .bse2-day-body { flex: 1; display: flex; flex-direction: column; gap: 4px; }
  .bse2-day-place {
    display: flex; align-items: center; gap: 3px;
    font-size: 10px; font-weight: 600; color: #374151;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }
  .bse2-day-salary {
    font-size: 12px; font-weight: 800;
    color: #DC2626; background: #FFF1F2;
    border-radius: 5px; padding: 2px 6px;
    display: inline-block;
  }
  .bse2-day-worked-badge {
    display: inline-flex; align-items: center; gap: 3px;
    background: #EDE9FE; border-radius: 5px; padding: 2px 6px;
    font-size: 10px; font-weight: 700; color: #7C3AED;
  }
  .bse2-day-layers {
    display: flex; align-items: center; gap: 3px;
    font-size: 10px; font-weight: 600; color: #6B7280;
  }
  .bse2-day-manager {
    display: flex; align-items: center; gap: 2px;
    background: #EDE9FE; border-radius: 4px; padding: 2px 5px;
    font-size: 9px; font-weight: 700; color: #7C3AED;
    overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  }
  .bse2-day-empty {
    flex: 1; display: flex; flex-direction: column;
    align-items: center; justify-content: center; gap: 4px;
  }
  .bse2-day-note-dot {
    position: absolute; bottom: 6px; right: 6px;
    width: 16px; height: 16px; border-radius: 5px;
    background: #FEF9C3; border: 1px solid #FDE68A;
    display: flex; align-items: center; justify-content: center;
  }

  .bse2-loading {
    display: flex; align-items: center; justify-content: center;
    height: 60vh; background: #F0F2F7;
  }
  .bse2-spinner {
    width: 36px; height: 36px;
    border: 3px solid #E5E7EB; border-top-color: #3B82F6;
    border-radius: 50%; animation: bse2-spin 0.75s linear infinite;
  }
  @keyframes bse2-spin { to { transform: rotate(360deg); } }
  .hide-scrollbar::-webkit-scrollbar { display: none; }
  .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
`;

export default function BossStatisticEmployeeData({ onBack }) {
  const { t } = useTranslation();
  const history = useHistory();
  const { employeeId } = useParams();
  const monthTrackRef = useRef(null);

  const [choosedEmployee, setChoosedEmployee] = useState(null);
  const [allData, setAllData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [choosedMonth, setChoosedMonth] = useState(null);
  const [loading, setLoading] = useState(true);

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedPlaceId, setSelectedPlaceId] = useState(null);
  const [existingEmployees, setExistingEmployees] = useState([]);

  const [isExporting, setIsExporting] = useState(false);
  const [showExportMenu, setShowExportMenu] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    const employee = localStorage.getItem("choosedEmployee");
    const data = localStorage.getItem("allData");
    const user = localStorage.getItem("user");
    const month =
      localStorage.getItem("choosedMonth") || moment().format("MM-YYYY");
    if (employee) setChoosedEmployee(JSON.parse(employee));
    if (data) setAllData(JSON.parse(data));
    if (user) setUserData(JSON.parse(user));
    setChoosedMonth(month);
    setLoading(false);
  }, []);

  useEffect(() => {
    if (choosedMonth) localStorage.setItem("choosedMonth", choosedMonth);
  }, [choosedMonth]);

  useEffect(() => {
    if (!choosedMonth || !monthTrackRef.current) return;
    const idx = monthList.findIndex((m) => m === choosedMonth);
    if (idx < 0) return;
    const btn = monthTrackRef.current.children[idx];
    if (btn)
      btn.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
  }, [choosedMonth]);

  useEffect(() => {
    const close = () => setShowExportMenu(false);
    if (showExportMenu) document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [showExportMenu]);

  const generateMonths = () => {
    const months = [];
    const now = new Date();
    for (let i = 0; i < 12; i++) {
      const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      months.push(
        `${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`,
      );
    }
    return months;
  };
  const monthList = generateMonths();

  const scrollMonths = (dir) => {
    if (monthTrackRef.current)
      monthTrackRef.current.scrollBy({ left: dir * 180, behavior: "smooth" });
  };

  const handleCreateSuccess = async () => {
    setShowCreateModal(false);
    setExistingEmployees([]);
    setSelectedPlaceId(null);
    if (userData) {
      try {
        const r = await axios.post(`${MyDomain}Employee/GetAllData`, {
          UserId: userData.id,
        });
        setAllData(r.data || {});
        localStorage.setItem("allData", JSON.stringify(r.data));
      } catch (e) {
        console.error(e);
      }
    }
  };

  const handleUpdateSuccess = async (updatedEmployee) => {
    setShowEditModal(false);
    if (updatedEmployee) {
      setChoosedEmployee(updatedEmployee);
      localStorage.setItem("choosedEmployee", JSON.stringify(updatedEmployee));
    }
    if (userData) {
      try {
        const r = await axios.post(`${MyDomain}Employee/GetAllData`, {
          UserId: userData.id,
        });
        setAllData(r.data || {});
        localStorage.setItem("allData", JSON.stringify(r.data));
        const synced = r.data.myEmployees?.find(
          (e) => e.id === (updatedEmployee?.id ?? choosedEmployee?.id),
        );
        if (synced) {
          setChoosedEmployee(synced);
          localStorage.setItem("choosedEmployee", JSON.stringify(synced));
        }
      } catch (e) {
        console.error(e);
      }
    }
  };

  const handleDeleteEmployee = async () => {
    setDeleteLoading(true);
    try {
      await axios.delete(`${MyDomain}Employee/DeleteEmployee/${choosedEmployee.id}`);
      setShowDeleteConfirm(false);
      if (onBack) {
        onBack();
      } else {
        history.push(`/boss-main-page/${userData?.id}`);
      }
    } catch (error) {
      console.error("Error deleting employee:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data ||
        "Failed to delete employee.";
      alert(`Error: ${errorMessage}`);
    } finally {
      setDeleteLoading(false);
    }
  };

  if (loading || !choosedEmployee || !allData) {
    return (
      <div className="bse2">
        <style>{STYLES}</style>
        <div className="bse2-loading">
          <div className="bse2-spinner" />
        </div>
      </div>
    );
  }

  const isMonthlyEmployee = choosedEmployee?.typeSalary === 2;
  const employeeSalary = isMonthlyEmployee
    ? choosedEmployee?.monthlySalary || 0
    : choosedEmployee?.salary || 0;

  const getAllDaysInMonth = () => {
    if (!choosedMonth) return [];
    const [month, year] = choosedMonth.split("-");
    const daysInMonth = moment(
      `${year}-${month}-01`,
      "YYYY-MM-DD",
    ).daysInMonth();
    return Array.from(
      { length: daysInMonth },
      (_, i) => `${String(i + 1).padStart(2, "0")}-${month}-${year}`,
    );
  };

  const filteredDailyWork = (allData?.myDailyWork || []).filter((item) => {
    if (!choosedEmployee?.id || !choosedMonth) return false;
    const [, month, year] = item.date.split("-");
    return (
      item.employeeId === choosedEmployee.id &&
      `${month}-${year}` === choosedMonth
    );
  });

  const groupedData = filteredDailyWork.reduce((g, item) => {
    if (!g[item.date]) g[item.date] = [];
    g[item.date].push(item);
    return g;
  }, {});

  const allDaysInMonth = getAllDaysInMonth();
  const workingDays = Object.keys(groupedData).length;

  const getDayTotal = (date) =>
    (groupedData[date] || []).reduce(
      (s, i) => s + (parseFloat(i.salary) || 0),
      0,
    );
  const hasNotes = (date) =>
    (groupedData[date] || []).some((i) => i.note && i.note.trim() !== "");
  const getPlaceName = (id) =>
    allData.myPlaces?.find((p) => p.id === id)?.place || `Place ${id}`;
  const getManagerName = (id) =>
    allData.myEmployees?.find((e) => e.id === id)?.name || "Me";
  const getDayName = (date) => moment(date, "DD-MM-YYYY").format("ddd");

  const totalSalary = isMonthlyEmployee
    ? workingDays > 0
      ? employeeSalary
      : 0
    : filteredDailyWork.reduce((s, i) => s + (parseFloat(i.salary) || 0), 0);
  const avgDailySalary = workingDays > 0 ? totalSalary / workingDays : 0;

  const handleDayClick = (date) => {
    const dayData = groupedData[date] || [];
    if (dayData.length > 0) {
      const placeId = dayData[0].placeId;
      const existingEmps = allData.myDailyWork
        .filter((i) => i.date === date && i.placeId === placeId)
        .map((i) => {
          const emp = allData.myEmployees.find((e) => e.id === i.employeeId);
          return {
            id: i.employeeId,
            name: emp?.name || `Employee ${i.employeeId}`,
            salary: i.salary.toString(),
          };
        });
      setSelectedDate(date);
      setSelectedPlaceId(placeId);
      setExistingEmployees(existingEmps);
    } else {
      setSelectedDate(date);
      setSelectedPlaceId(null);
      setExistingEmployees([
        {
          id: choosedEmployee.id,
          name: choosedEmployee.name,
          salary: isMonthlyEmployee ? "0" : employeeSalary.toString(),
        },
      ]);
    }
    setShowCreateModal(true);
  };

  const generateReportHTML = () => {
    const monthName = moment(choosedMonth, "MM-YYYY").format("MMMM YYYY");
    let rows = "";
    allDaysInMonth.forEach((date) => {
      const dayData = groupedData[date] || [];
      if (!dayData.length) return;
      rows += `<tr><td>${moment(date, "DD-MM-YYYY").format("DD")}</td><td>${getDayName(date)}</td><td>${getPlaceName(dayData[0].placeId)}</td><td>${!isMonthlyEmployee ? `₪${getDayTotal(date).toFixed(2)}` : "Worked"}</td></tr>`;
    });
    return `<!DOCTYPE html><html><head><meta charset="utf-8"><style>body{font-family:Arial,sans-serif;padding:40px}.header{text-align:center;margin-bottom:30px;border-bottom:3px solid #3B82F6;padding-bottom:20px}.header h1{color:#3B82F6;font-size:28px;margin:0}.header h2{color:#6B7280;font-size:16px;font-weight:normal;margin:8px 0 0}table{width:100%;border-collapse:collapse}th{background:#3B82F6;color:#fff;padding:10px;text-align:left}td{padding:10px;border-bottom:1px solid #E5E7EB}.totals{margin-top:24px;display:flex;gap:32px;justify-content:flex-end}.totals-box{background:#F0F9FF;border:1px solid #BAE6FD;border-radius:8px;padding:14px 24px;text-align:center}.totals-box .lbl{font-size:12px;color:#6B7280;margin-bottom:4px}.totals-box .val{font-size:20px;font-weight:700;color:#1D4ED8}.footer{text-align:center;margin-top:30px;color:#6B7280;font-size:12px}</style></head><body><div class="header"><h1>Work History</h1><h2>${choosedEmployee?.name} — ${monthName}</h2></div><table><thead><tr><th>Day</th><th>Day Name</th><th>Place</th><th>Salary</th></tr></thead><tbody>${rows}</tbody></table><div class="totals"><div class="totals-box"><div class="lbl">Total Days</div><div class="val">${workingDays}</div></div><div class="totals-box"><div class="lbl">Total Salary</div><div class="val">₪${totalSalary.toLocaleString()}</div></div></div><div class="footer">Generated ${new Date().toLocaleString()}</div></body></html>`;
  };

  const exportToPDF = () => {
    setIsExporting(true);
    setShowExportMenu(false);
    try {
      const win = window.open("", "_blank");
      win.document.write(generateReportHTML());
      win.document.close();
      win.focus();
      setTimeout(() => {
        win.print();
        setIsExporting(false);
      }, 500);
    } catch {
      setIsExporting(false);
    }
  };

  const exportToExcel = () => {
    setIsExporting(true);
    setShowExportMenu(false);
    try {
      const rows = [
        ["Work History"],
        [
          `${choosedEmployee?.name} — ${moment(choosedMonth, "MM-YYYY").format("MMMM YYYY")}`,
        ],
        [],
        ["Day", "Day Name", "Place", "Salary", "Manager", "Notes"],
      ];
      allDaysInMonth.forEach((date) => {
        const dd = groupedData[date] || [];
        if (!dd.length) return;
        rows.push([
          moment(date, "DD-MM-YYYY").format("DD"),
          getDayName(date),
          getPlaceName(dd[0].placeId),
          !isMonthlyEmployee ? `₪${getDayTotal(date).toFixed(2)}` : "Worked",
          dd[0].whoMake ? getManagerName(dd[0].whoMake) : "-",
          dd
            .map((d) => d.note)
            .filter((n) => n?.trim())
            .join(", ") || "-",
        ]);
      });
      const csv =
        "data:text/csv;charset=utf-8," +
        rows.map((r) => r.map((c) => `"${c}"`).join(",")).join("\n");
      const a = document.createElement("a");
      a.setAttribute("href", encodeURI(csv));
      a.setAttribute(
        "download",
        `${choosedEmployee?.name}_${choosedMonth}.csv`,
      );
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (e) {
      console.error(e);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="bse2">
      <style>{STYLES}</style>

      <header className="bse2-header">
        <div className="bse2-topbar">
          <button className="bse2-back" onClick={() => onBack ? onBack() : history.goBack()}>
            <ChevronLeft size={18} />
          </button>
          <div className="bse2-actions">
            <div className="bse2-export-wrap">
              <button
                className="bse2-action-btn export"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowExportMenu((p) => !p);
                }}
                disabled={isExporting}
                title="Export"
              >
                <Download size={16} />
              </button>
              {showExportMenu && (
                <div
                  className="bse2-export-menu"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button className="bse2-export-item" onClick={exportToPDF}>
                    <FileText size={14} color="#DC2626" /> {t("export")} PDF
                  </button>
                  <div className="bse2-export-sep" />
                  <button className="bse2-export-item" onClick={exportToExcel}>
                    <FileText size={14} color="#059669" /> {t("export")} CSV
                  </button>
                </div>
              )}
            </div>
            <button
              className="bse2-action-btn edit"
              onClick={() => setShowEditModal(true)}
              title="Edit"
            >
              <Edit2 size={15} />
            </button>
            <button
              className="bse2-action-btn delete"
              onClick={() => setShowDeleteConfirm(true)}
              title="Delete employee"
            >
              <Trash2 size={15} />
            </button>
          </div>
        </div>

        <div className="bse2-emp-row">
          <div className="bse2-avatar">
            <User size={24} color="#fff" />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <p className="bse2-emp-name">{choosedEmployee?.name}</p>
            <div className="bse2-emp-sub">
              <span className="bse2-emp-label">
                ID #{String(choosedEmployee?.id).padStart(4, "0")}
              </span>
              <span
                className={`bse2-salary-badge ${isMonthlyEmployee ? "monthly" : "daily"}`}
              >
                <CalendarIcon size={9} />
                {isMonthlyEmployee ? t("monthly") : t("daily")}
              </span>
            </div>
          </div>
        </div>

        <div className="bse2-salary-strip">
          <span className="bse2-salary-strip-lbl">
            {isMonthlyEmployee ? t("baseMonthly") : t("baseDaily")} {t("salary")}
          </span>
          <span className="bse2-salary-strip-val">
            ₪{employeeSalary.toLocaleString()}
          </span>
        </div>
      </header>

      <div className="bse2-body">
        {/* Month scroller */}
        <div className="bse2-month-section">
          <p className="bse2-section-title">{t("selectMonth")}</p>
          <div className="bse2-month-row">
            <button
              className="bse2-month-arrow"
              onClick={() => scrollMonths(-1)}
            >
              <ChevronLeft size={14} />
            </button>
            <div className="bse2-month-scroll-wrap">
              <div className="bse2-month-track" ref={monthTrackRef}>
                {monthList.map((item) => {
                  const [, year] = item.split("-");
                  return (
                    <button
                      key={item}
                      className={`bse2-month-btn${choosedMonth === item ? " active" : ""}`}
                      onClick={() => setChoosedMonth(item)}
                    >
                      <span className="bse2-month-name">
                        {moment(item, "MM-YYYY").format("MMM")}
                      </span>
                      <span className="bse2-month-year">{year}</span>
                    </button>
                  );
                })}
              </div>
            </div>
            <button
              className="bse2-month-arrow"
              onClick={() => scrollMonths(1)}
            >
              <ChevronRight size={14} />
            </button>
          </div>
        </div>

        {/* Summary */}
        <div className="bse2-summary">
          <div className="bse2-sum-card blue">
            <div className="bse2-sum-ico blue">
              <CalendarIcon size={14} color="#3B82F6" />
            </div>
            <div className="bse2-sum-val">{workingDays}</div>
            <div className="bse2-sum-lbl">{t("workDays")}</div>
          </div>
          <div className="bse2-sum-card green">
            <div className="bse2-sum-ico green">
              <DollarSign size={14} color="#059669" />
            </div>
            <div className="bse2-sum-val">₪{totalSalary.toLocaleString()}</div>
            <div className="bse2-sum-lbl">
              {isMonthlyEmployee ? t("salary") : t("total")}
            </div>
          </div>
          <div className="bse2-sum-card purple">
            <div className="bse2-sum-ico purple">
              <TrendingUp size={14} color="#7C3AED" />
            </div>
            <div className="bse2-sum-val">₪{avgDailySalary.toFixed(0)}</div>
            <div className="bse2-sum-lbl">{t("avgPerDay")}</div>
          </div>
        </div>

        {isMonthlyEmployee && workingDays > 0 && (
          <div className="bse2-monthly-note">
            <TrendingUp size={14} color="#7C3AED" style={{ flexShrink: 0 }} />₪
            {employeeSalary.toLocaleString()} ÷ {workingDays} days = ₪
            {avgDailySalary.toFixed(2)}/day
          </div>
        )}

        {/* Work history */}
        <div>
          <div className="bse2-wh-header">
            <span className="bse2-wh-title">{t("workHistory")}</span>
            {choosedMonth && (
              <span className="bse2-wh-month-badge">
                {moment(choosedMonth, "MM-YYYY").format("MMM YYYY")}
              </span>
            )}
          </div>

          {allDaysInMonth.length === 0 ? (
            <div
              style={{
                textAlign: "center",
                padding: "40px 20px",
                color: "#9CA3AF",
                fontSize: 13,
              }}
            >
              Select a month to view work history
            </div>
          ) : (
            <div className="bse2-day-grid">
              {allDaysInMonth.map((date) => {
                const dayData = groupedData[date] || [];
                const hasWork = dayData.length > 0;
                const isToday = moment(date, "DD-MM-YYYY").isSame(
                  moment(),
                  "day",
                );
                const dayTotal = getDayTotal(date);

                return (
                  <button
                    key={date}
                    className={`bse2-day${hasWork ? " worked" : ""}${isToday ? " today" : ""}`}
                    onClick={() => handleDayClick(date)}
                  >
                    {hasNotes(date) && (
                      <div className="bse2-day-note-dot">
                        <FileText size={9} color="#D97706" />
                      </div>
                    )}
                    <div className="bse2-day-top">
                      <span className="bse2-day-num">
                        {moment(date, "DD-MM-YYYY").format("DD")}
                      </span>
                      <span className="bse2-day-name">{getDayName(date)}</span>
                    </div>
                    <div className="bse2-day-body">
                      {hasWork ? (
                        <>
                          <div className="bse2-day-place">
                            <MapPin
                              size={10}
                              color="#059669"
                              style={{ flexShrink: 0 }}
                            />
                            <span
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {getPlaceName(dayData[0].placeId)}
                            </span>
                          </div>
                          {!isMonthlyEmployee ? (
                            <span className="bse2-day-salary">
                              ₪{dayTotal.toFixed(0)}
                            </span>
                          ) : (
                            <div className="bse2-day-worked-badge">
                              <CheckCircle size={10} /> {t("worked")}
                            </div>
                          )}
                          {dayData.length > 1 && (
                            <div className="bse2-day-layers">
                              <Layers size={10} /> {dayData.length}
                            </div>
                          )}
                          {dayData[0].whoMake && (
                            <div className="bse2-day-manager">
                              <Shield size={9} />
                              <span
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {getManagerName(dayData[0].whoMake)}
                              </span>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="bse2-day-empty">
                          <PlusCircle size={22} color="#D1D5DB" />
                          <span
                            style={{
                              fontSize: 10,
                              color: "#9CA3AF",
                              fontWeight: 600,
                            }}
                          >
                            {t("noWork")}
                          </span>
                        </div>
                      )}
                    </div>
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>

      <BossCreateDayWork
        visible={showCreateModal}
        onClose={() => {
          setShowCreateModal(false);
          setExistingEmployees([]);
          setSelectedPlaceId(null);
        }}
        onSuccess={handleCreateSuccess}
        places={allData.myPlaces}
        employees={allData.myEmployees}
        preselectedDate={selectedDate}
        preselectedPlaceId={selectedPlaceId}
        preselectedEmployees={existingEmployees}
      />
      <BossUpdateEmployeeModal
        visible={showEditModal}
        onClose={() => setShowEditModal(false)}
        employee={choosedEmployee}
        onUpdateSuccess={handleUpdateSuccess}
      />

      {showDeleteConfirm && (
        <div className="bse2-delete-overlay" onClick={() => !deleteLoading && setShowDeleteConfirm(false)}>
          <div className="bse2-delete-sheet" onClick={(e) => e.stopPropagation()}>
            <div className="bse2-delete-icon-wrap">
              <AlertTriangle size={26} color="#DC2626" />
            </div>
            <p className="bse2-delete-title">Delete {choosedEmployee?.name}?</p>
            <p className="bse2-delete-desc">
              This will permanently delete the employee and all their daily work records. This action cannot be undone.
            </p>
            <div className="bse2-delete-btns">
              <button
                className="bse2-delete-cancel"
                onClick={() => setShowDeleteConfirm(false)}
                disabled={deleteLoading}
              >
                Cancel
              </button>
              <button
                className="bse2-delete-confirm"
                onClick={handleDeleteEmployee}
                disabled={deleteLoading}
              >
                {deleteLoading ? (
                  <>
                    <div style={{ width: 16, height: 16, border: "2px solid rgba(255,255,255,0.4)", borderTopColor: "#fff", borderRadius: "50%", animation: "bse2-spin 0.75s linear infinite" }} />
                    Deleting...
                  </>
                ) : (
                  <>
                    <Trash2 size={15} />
                    Yes, Delete
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
